/* eslint rxjs/no-nested-subscribe: "warn"
--------
TODO: refactor and cleanup these nested subscribes.
DON'T COPY THIS WARN OVERRIDE TO NEW FILES;
IT'S ONLY HERE TO ALLOW TIME FOR FIXES IN EXISTING FILES
*/
import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService, ApConfirmModalService, ApModalService } from 'webcommon/core-ui';
import {
  EResponsiblePartyType, FindControlAdditionalSearchParametersType, FindControlResultDto,
  FindControlSearchDto,
  FormGroupValidationRules
} from 'webcommon/shared';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { MatRadioChange } from '@angular/material/radio';
import { FindControlIdService } from 'webcommon/legacy-common';
import { ApFindControlModalService } from '../../ap-findcontrol-modal.service';
import { FcItemModalMode } from '../../../models';
import { FcEmploymentListModalComponent } from '../fc-employment-list-modal/fc-employment-list-modal.component';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-responsible-party-list-modal',
  templateUrl: './fc-responsible-party-list-modal.component.html',
  styleUrls: ['./fc-responsible-party-list-modal.component.less']
})
export class FcResponsiblePartyListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-responsible-party-item';
  public override isSubmitted = false;
  public personListItem: any = {
    Id: '',
    PersonUid: '',
    PatientCenterUid: '',
    PatientCenter: '',
    Inactive: false,
    Notes: '',

    // Name details
    Prefix: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Suffix: '',
    MaidenName: '',
    PronounUid: '',
    AkaFirstName: '',
    AkaLastName: '',

    // Other information
    GenderUid: '',
    BirthGenderUid: '',
    GenderIdentityUid: '',
    SexualOrientationUid: '',
    BirthDate: null,
    BirthTime: null,
    DeathDate: '',
    MaritalStatusUid: '',
    RaceUids: [],
    EthnicityUids: [],
    LanguageUid: '',
    TranslatorRequired: false,
    DominantHandUid: '',
    SocialSecurityNumber: '',
    DriverLicenseNumber: '',
    DriverLicenseState: '',

    // Addresses
    BadAddress1: false,
    Address1: {
      ZipUid: '',
      CountyName: '',
      CountyCode: '',
      Address1: '',
      Address2: '',
      City: '',
      State: '',
      Zip: '',
      Country: '',
    },
    Address2: {
      ZipUid: '',
      CountyName: '',
      CountyCode: '',
      Address1: '',
      Address2: '',
      City: '',
      State: '',
      Zip: '',
      Country: '',
    },

    // Contact information
    Phone1: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: ''
    },
    Phone1MessagingAllowed: false,
    Phone1SmsEnabledDefault: false,
    Phone2: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: ''
    },
    Phone2MessagingAllowed: false,
    Phone2SmsEnabledDefault: false,
    Phone3: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: ''
    },
    Phone3MessagingAllowed: false,
    Phone3SmsEnabledDefault: false,
    Phone4: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: ''
    },
    Phone4MessagingAllowed: false,
    Phone4SmsEnabledDefault: false,
    Email1: '',
    Email2: '',
    Email1MessagingAllowed: false,
    Email2MessagingAllowed: false,
    NoEmailAddressProvided: false,
    PreferredContactMethod: '',
  };
  public corporationListItem: any = {
    Id: '',
    ExternalID: '',
    Name: '',
    PrimaryContact: '',
    SecondaryContact: '',
    Address: {
      Address1: '',
      Address2: '',
      City: '',
      State: '',
      Zip: '',
      CountyName: '',
      CountyCode: '',
    },
    Phone1: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Phone2: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Phone3: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Phone4: {
      PhoneNumber: '',
      PhoneType: '',
      PhoneTypeUid: '',
    },
    Email1: '',
    Email2: '',
    CorpNotes: '',
    Inactive: false,
  };
  public listItem: any = {
    Person: this.personListItem,
    Corporation: this.corporationListItem
  };
  public listItemDefaultValidation: FormGroupValidationRules = {};

  public externalIdControl: FormControl = new FormControl('');
  public corporationFormGroup: FormGroup = new FormGroup<any>({});
  public personFormGroup: FormGroup = new FormGroup<any>({});
  public inactiveControl: FormControl = new FormControl('');
  public notesControl: FormControl = new FormControl<string>('');
  public form: FormGroup = new FormGroup({
    externalId: this.externalIdControl,
    inactive: this.inactiveControl,
    corporation: this.corporationFormGroup,
    notes: this.notesControl,
    person: this.personFormGroup
  });

  public responsiblePartyEnum = EResponsiblePartyType;
  public fcItemModalModeEnum = FcItemModalMode;

  public selectedType = this.responsiblePartyEnum.PERSON;

  constructor(
    public injector: Injector,
    private apFindControlModalService: ApFindControlModalService,
    private confirmModalService: ApConfirmModalService,
    private apModalService: ApModalService
  ) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.fcModalItemContext.mode === FcItemModalMode.New) {
      this.externalIdControl.setValue('(Auto ID)');
    }
    this.externalIdControl.disable();
    this.loadListItem({
      // Name details
      Prefix: {
        MaxLength: 25,
      },
      FirstName: {
        IsRequired: true,
        MaxLength: 50,
      },
      MiddleName: {
        MaxLength: 50,
      },
      LastName: {
        IsRequired: true,
        MaxLength: 50,
      },
      Suffix: {
        MaxLength: 50,
      },
      MaidenName: {
        MaxLength: 50,
      },
      AkaFirstName: {
        MaxLength: 50,
      },
      AkaLastName: {
        MaxLength: 50,
      },
      SocialSecurityNumber: {
        MaxLength: 11,
        RegExp: '([0-9]{3}-[0-9]{2}-[0-9]{4})',
      },
      DriverLicenseNumber: {
        MaxLength: 25,
      },
      DriverLicenseState: {
        MaxLength: 3,
      },
      PhoneNumber: {
        MaxLength: 22,
        RegExp: '^(([0-9]{3}-[0-9]{4})|((\\([0-9]{3}\\)[0-9]{3}-[0-9]{4})( x[0-9]{1,7})?))$',
      },
      PhoneType: {},
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public override setForm(): void {
    if (this.listItem) {
      if (this.listItem?.PersonEmployerRelation && this.listItem?.PersonEmployerRelation.length) {
        this.listItem.PersonEmployerRelation = this.listItem.PersonEmployerRelation.map((item: any) => {
          return Object.assign({}, item, {Id: new Date().getTime()});
        });
      }
    }
    if (this.fcModalItemContext.mode === FcItemModalMode.Modify) {
      this.externalIdControl.setValue(this.listItem?.ExternalID);
    }
  }

  public onSelectExistingPerson(): void {

    if (this.selectedType === this.responsiblePartyEnum.PERSON) {
      this.triggerFindControlModal(FindControlIdService.ViewFindPerson, 'Find Person');
    } else {
      this.triggerFindControlModal(FindControlIdService.ViewCorporation, 'Find Corporation');
    }
  }

  public onChangeRadioBtn(event: MatRadioChange): void {
    this.selectedType = event.value;
    if (this.selectedType === this.responsiblePartyEnum.PERSON) {
      this.personFormGroup.reset();
    } else {
      this.corporationFormGroup.reset();
    }
  }

  public onNewClick(): void {
    const initialState: any = {
      mode: FcItemModalMode.New,
      item: this.listItem,
    };
    this.apModalService.showComponentModal(FcEmploymentListModalComponent, {
      panelClass: ['emds-modal-medium', 'emds-modal-medium-fixed'],
      disableClose: true,
      initialState
    }).then((res: any) => {
      if (!!res.resultValue.result) {
        const itemForAdding = {
          Department: res.resultValue.result.Department,
          StartDate: res.resultValue.result.StartDate,
          EndDate: res.resultValue.result.EndDate,
          EmployerName: res.resultValue.result.EmployerName,
          EmployerUid: res.resultValue.result.EmployerUid,
          EmploymentStatusName: res.resultValue.result.EmploymentStatusName,
          EmploymentStatusUid: res.resultValue.result.EmploymentStatusUid,
          OccupationName: res.resultValue.result.OccupationName,
          OccupationUid: res.resultValue.result.OccupationUid,
          IndustryName: res.resultValue.result.IndustryName,
          IndustryUid: res.resultValue.result.IndustryUid,
          Id: res.resultValue.result.Id
        };
        if (this.listItem.PersonEmployerRelation) {
          this.listItem.PersonEmployerRelation = [...this.listItem.PersonEmployerRelation, itemForAdding];
        } else {
          this.listItem.PersonEmployerRelation = [];
          this.listItem.PersonEmployerRelation.push(itemForAdding);
        }
      }
    });
  }

  public onEditTableItem(event: MouseEvent, tableItem: any): void {
    event.stopPropagation();

    const initialState: any = {
      mode: FcItemModalMode.Modify,
      item: this.listItem,
      itemForModify: tableItem,
      fullName: `${this.listItem.Person.LastName}, ${this.listItem.Person.FirstName}`
    };
    this.apModalService.showComponentModal(FcEmploymentListModalComponent, {
      panelClass: ['emds-modal-medium', 'emds-modal-medium-fixed'],
      disableClose: true,
      initialState
    }).then((res: any) => {
      if (!!res.resultValue.result) {
        const foundItemIndex = this.listItem.PersonEmployerRelation.findIndex(((item: any) => item.Id === res.resultValue.result.Id));
        if (foundItemIndex !== -1) {
          this.listItem.PersonEmployerRelation.splice(foundItemIndex, 1, res.resultValue.result);
        }
      }
    });
  }

  public onDeleteTableItem(event: MouseEvent, tableItem: any): void {
    event.stopPropagation();
    this.listItem.PersonEmployerRelation = this.listItem.PersonEmployerRelation.filter((item: any) => item.Id !== tableItem.Id);
  }

  public override save(): void {
    const values = this.form.getRawValue();
    this.isSubmitted = true;

    const modifyItemDto = {...values};

    super.save<any>(modifyItemDto);
  }

  private triggerFindControlModal(findControlIdService: string, displayName: string): void {
    this.apFindControlModalService.openModal(
      this.injector,
      findControlIdService,
      [],
      this.baseId,
      displayName,
      1,
      undefined,
      undefined,
      undefined,
    ).pipe(
      this.takeUntilDestroy(),
    ).subscribe(
      (result: any) => {
        if (result) {

          if (result.resultValue != null) {
            if (result.resultValue[0].CorporationUid) {
              const searchDto: FindControlSearchDto = {
                AdditionalSearchParameters: {
                  Type: FindControlAdditionalSearchParametersType.Standard,
                  AdditionalSearchParameters: [
                    {
                      ColumnName: 'CorporationUid',
                      Value: result.resultValue[0].CorporationUid,
                      Negate: false
                    },
                  ],
                },
                Prepopulate: false,
                RequiredSearchParameters: {
                  RequiredSearchParameters: [],
                },
                SearchText: '',
                ShowInactive: false,
              };

              this.findControlRepository.getData(FindControlIdService.ViewResponsibleParty, searchDto)
                .subscribe((data) => {
                  if (data.Rows.length) {
                    if (data.Rows[0].ResponsiblePartyUid) {
                      this.confirmModalService
                        .openModal(
                          this.baseId,
                          'This entity is already an account responsible party. Do you want to use that record?',
                          'Duplicate Found',
                          'Confirm',
                          'Cancel',
                          'emds-modal-small-fixed',
                          null,
                          null
                        )
                        .then((response) => {
                          if (response) {
                            const requiredSearchParams = {
                              RequiredSearchParameters: [],
                            };
                            const searchCorporationDto: FindControlSearchDto = {
                              AdditionalSearchParameters: null,
                              Prepopulate: false,
                              RequiredSearchParameters: requiredSearchParams,
                              SearchText: data.Rows[0].Name,
                              ShowInactive: false,
                            };

                            this.findControlRepository.getData(FindControlIdService.ViewResponsibleParty, searchCorporationDto)
                              .subscribe(((res: FindControlResultDto) => {
                                this.apClose(res.Rows[0]);
                              }));
                          }
                        });
                    }
                  } else {
                    this.findControlRepository.getItem(FindControlIdService.ViewCorporation, result.resultValue[0].CorporationUid)
                      .subscribe((corpData: any) => {
                        this.corporationListItem = corpData;
                        this.listItem = {
                          Corporation: this.corporationListItem,
                          Person: this.personListItem
                        };
                      });
                  }
                });
            } else {

              this.corporationListItem = result.resultValue[0];
              this.listItem = {
                Corporation: this.corporationListItem,
                Person: this.personListItem
              };
            }
          }

          if (result.resultValue != null) {
            if (result.resultValue[0].ResponsiblePartyExternalID) {
              const searchStr = result.resultValue[0].FullName;
              this.confirmModalService
                .openModal(
                  this.baseId,
                  'This entity is already an account responsible party. Do you want to use that record?',
                  'Duplicate Found',
                  'Confirm',
                  'Cancel',
                  'emds-modal-small-fixed',
                  null,
                  null
                )
                .then((res) => {
                  if (res) {
                    const requiredSearchParams = {
                      RequiredSearchParameters: [],
                    };
                    const searchDto: FindControlSearchDto = {
                      AdditionalSearchParameters: null,
                      Prepopulate: false,
                      RequiredSearchParameters: requiredSearchParams,
                      SearchText: searchStr,
                      ShowInactive: false,
                    };

                    this.findControlRepository.getData(FindControlIdService.ViewResponsibleParty, searchDto).subscribe((data => {
                      this.apClose(data.Rows[0]);
                    }));
                  }
                });
            } else {
              this.personListItem = Object.assign({}, {
                FirstName: result?.resultValue[0].FirstName,
                LastName: result?.resultValue[0].LastName,
              });
              this.listItem = {
                Person: this.personListItem
              };
            }
          }
        }
      }
    );
  }

  public isSelectedTypePerson(): boolean {
    return this.selectedType === this.responsiblePartyEnum.PERSON;
  }
}
